export function createFacilitySearchFields() {
  {
    return {
      nameFilter: '',
      facilityId:0,
      facilityName:'',
      statusFilters: {
        filters: [],
        isAnd: false
      },
      ownerFilters: {
        filters: [],
        isAnd: false
      },
      specialtyFilters: {
        filters: [],
        isAnd: false
      },
      stateAddressFilters: {
        filters: [],
        isAnd: false
      },
      boardCertified: {
        isRequired: -1
      },
      certificationFilters: {
        filters: [],
        isAnd: false
      },
      providerTypeFilters: {
        filters: [],
        isAnd: false
      },
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/facilities/models/FacilityAdvancedSearchModel.ts